import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLang } from "../lib/LanguageContext";
import { BRAND } from "../lib/menuData";

export const About = () => {
  const { t } = useLang();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-brand-cream"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden ring-1 ring-brand-border">
              <img
                src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=1200&q=85&auto=format&fit=crop"
                alt="Cozy interior of Hayalan Coffee"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="hidden md:block absolute -bottom-10 -right-10 aspect-square w-44 rounded-2xl overflow-hidden ring-1 ring-brand-border shadow-xl">
              <img
                src={BRAND.storefront}
                alt="Hayalan Coffee at night"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            {/* Gold accent */}
            <div className="hidden md:flex absolute -top-6 -left-6 w-24 h-24 rounded-full bg-brand-gold/90 text-brand-coffee items-center justify-center font-serif text-sm italic shadow-lg">
              4.7 ★
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <span className="text-xs uppercase tracking-[0.32em] text-brand-blue font-medium">
              {t.about.eyebrow}
            </span>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.1] tracking-tight text-brand-ink whitespace-pre-line">
              {t.about.title}
            </h2>

            <p className="mt-6 text-base md:text-lg text-brand-mocha leading-relaxed">
              {t.about.p1}
            </p>
            <p className="mt-4 text-base md:text-lg text-brand-mocha leading-relaxed">
              {t.about.p2}
            </p>

            <ul className="mt-10 grid sm:grid-cols-2 gap-x-6 gap-y-4">
              {t.about.bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3"
                  data-testid={`about-bullet-${i}`}
                >
                  <span className="mt-0.5 flex-shrink-0 w-6 h-6 rounded-full bg-brand-blue/10 flex items-center justify-center">
                    <Check
                      className="w-3.5 h-3.5 text-brand-blue"
                      strokeWidth={2.4}
                    />
                  </span>
                  <span className="text-sm md:text-base text-brand-ink/90">
                    {b}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
